(() => {
  if (window.fellauraRecommendationsBound) return;
  window.fellauraRecommendationsBound = true;
  const root = window.Shopify?.routes?.root || '/';
  let timer, controller, serial = 0;
  const mounts = () => [...document.querySelectorAll('[data-fellaura-recommendations]')];
  async function refresh() {
    if (!mounts().length) return;
    const version = ++serial;
    controller?.abort();
    controller = new AbortController();
    try {
      const url = new URL(root + 'cart', location.origin);
      url.searchParams.set('section_id', 'fellaura-cart-recommendations');
      const response = await fetch(url, {signal: controller.signal, cache: 'no-store'});
      if (!response.ok) throw new Error('Recommendations unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-rec-content]');
      if (!content || version !== serial) return;
      mounts().forEach(mount => {
        const track = mount.querySelector('.fl-rec-track');
        const position = track?.scrollLeft || 0;
        const active = document.activeElement;
        const activeProduct = mount.contains(active) ? active.closest('[data-product-id]')?.dataset.productId : null;
        mount.replaceChildren(content.cloneNode(true));
        const newTrack = mount.querySelector('.fl-rec-track');
        if (newTrack) newTrack.scrollLeft = position;
        if (activeProduct) {
          const target = [...mount.querySelectorAll('[data-product-id]')].find(el => el.dataset.productId === activeProduct)?.querySelector('[data-rec-add]');
          (target || newTrack)?.focus({preventScroll: true});
        }
      });
    } catch (error) {
      if (error.name !== 'AbortError') mounts().forEach(mount => mount.replaceChildren());
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 180); }
  document.addEventListener('fellaura:cart-updated', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-rec-direction]');
    if (!arrow) return;
    const track = arrow.closest('[data-rec-content]').querySelector('.fl-rec-track');
    track.scrollBy({left: Number(arrow.dataset.recDirection) * track.clientWidth * .9, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-rec-form] select');
    if (!select) return;
    const option = select.selectedOptions[0], card = select.closest('.fl-rec-card');
    card.querySelector('[data-rec-price]').textContent = option.dataset.price;
    const compare = card.querySelector('[data-rec-compare]');
    compare.textContent = option.dataset.compare;
    compare.hidden = option.dataset.sale !== 'true';
    card.querySelector('.fl-rec-sale').hidden = compare.hidden;
    const image = card.querySelector('img');
    if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    const link = card.querySelector('.fl-rec-image'), url = new URL(link.href);
    url.searchParams.set('variant', option.value); link.href = url.href;
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-rec-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-rec-add]');
    if (button.disabled) return;
    const content = form.closest('[data-rec-content]'), status = form.querySelector('.fl-rec-error');
    const label = button.textContent;
    button.disabled = true; button.textContent = content.dataset.adding; status.textContent = '';
    let added = false;
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:form.elements.id.value,quantity:1}]})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || content.dataset.error);
      added = true;
      window.theme.miniCart.generateCart();
      window.theme.miniCart.updateElements();
      schedule();
    } catch (error) {
      status.textContent = added ? content.dataset.error : error.message || content.dataset.error;
    } finally { button.disabled = false; button.textContent = label; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
})();
